module.exports = __webpack_public_path__ + "static/5@3x-2cf26b626309a037cd82a4c82aa3ec75.png";